import Image from './image'

export default class Company {
  constructor(object) {
    this.name = object.name
    this.token = object.token
    this.logo = object.logo ? new Image(object.logo) : undefined
  }
}
